import { faArchive } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CreatedByLabel } from 'assets/js/pages/contacts/single/timeline/timeline-list/item/components/CreatedByLabel';
import * as ActivityItem from 'assets/js/pages/contacts/single/timeline/timeline-list/item/items/ActivityItem';
import { Contact, UnarchivedActivity } from 'types/domain';

const Unarchived = ({ item, contact }: { item: UnarchivedActivity; contact: Contact | null }) => {
    return (
        <ActivityItem.Root>
            <ActivityItem.Trigger disabled>
                <ActivityItem.Icon className="bg-orange-50">
                    <FontAwesomeIcon className="text-orange-500" icon={faArchive} />
                </ActivityItem.Icon>
                <p>
                    <CreatedByLabel createdBy={item.created_by} /> unarchived{' '}
                    <span className="font-medium">
                        {contact?.first_name} {contact?.last_name}
                    </span>
                </p>
            </ActivityItem.Trigger>
        </ActivityItem.Root>
    );
};

export { Unarchived };
